import Alert from './alert';
import { TYPE, VARIANT } from './constants';

export default Alert;
export { TYPE, VARIANT };
